import * as React from 'react';
import type { ColumnDef } from '../components/data-table';
import { useColumnPreferences } from '../components/data-table-column-preferences';
import { applyStoredWidth } from './ordered-visible-columns';

export function usePersistedDataTableColumns<T>(
  columns: ColumnDef<T>[],
  storageKeyPrefix: string,
): {
  columns: ColumnDef<T>[];
  onColumnResizeEnd: (columnId: string, widthPx: number) => void;
} {
  const allColumnIds = React.useMemo(() => columns.map((column) => column.id), [columns]);
  const { columnWidths, setColumnWidth } = useColumnPreferences({
    storageKeyPrefix,
    allColumnIds,
  });
  const persistedColumns = React.useMemo(
    () => columns.map((column) => applyStoredWidth(column, columnWidths)),
    [columns, columnWidths],
  );

  return { columns: persistedColumns, onColumnResizeEnd: setColumnWidth };
}
